import React from 'react';

const KillFeed = ({ kills }) => {
  if (!kills || kills.length === 0) {
    return (
      <div className="kill-feed empty">
        <span className="no-kills">Waiting for action...</span>
      </div>
    );
  }

  return (
    <div className="kill-feed">
      {kills.map((kill, index) => (
        <div key={`${kill.timestamp}-${index}`} className={`kill-entry ${kill.teamkill ? 'teamkill' : ''} ${kill.suicide ? 'suicide' : ''}`}>
          {kill.attacker && !kill.suicide && (
            <span className={`player attacker ${kill.attacker.team}`}>
              {kill.attacker.name}
            </span>
          )}
          <span className="kill-action">
            <span className="weapon-name">{kill.weapon || 'killed'}</span>
            {kill.headshot && <span className="modifier headshot">HS</span>}
          </span>
          <span className={`player victim ${kill.victim?.team}`}>
            {kill.victim?.name}
          </span>
        </div>
      ))}
    </div>
  );
};

export default KillFeed;
